import logoUDA from '../../assets/logo-uda-symbol.svg';


export const Footer = (props) => {

  return (
    <div
      className="flex w-full footer gap-2 items-center"
    >
    </div>
  );
};

export default Footer;
